<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['update:modelValue', 'update:focused']);
const { t } = useI18n({ useScope: 'global' });
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);

const languages = computed(() => [
    { title: t('Spanish'), value: 'es' },
    { title: t('English'), value: 'en' }
]);
</script>

<template>
    <v-select
        v-model="selected"
        :items="languages"
        item-title="title"
        item-value="value"
        :label="hideLabel ? '' : 'Language'"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
